// React
import React from "react";
import { toast } from "react-toastify";
// Adobe spectrum components
import Alert from "@spectrum-icons/workflow/Alert";
import CheckmarkCircle from "@spectrum-icons/workflow/CheckmarkCircle";
import Info from "@spectrum-icons/workflow/Info";

// Default function
const displayToasts = (payload: any) => {
  // Depending on the type
  switch (payload.type) {
    case "error":
      toast.error(payload.text, {
        icon: <Alert />,
        hideProgressBar: true,
        autoClose: payload.autoClose ? 10000 : false,
        className: "error-toast",
        bodyClassName: "toast-body",
      });
      break;
    case "success":
      toast.success(payload.text, {
        icon: <CheckmarkCircle />,
        hideProgressBar: true,
        autoClose: payload.autoClose ? 10000 : false,
        className: "success-toast",
        bodyClassName: "toast-body",
      });
      break;
    case "warning":
      toast.error(payload.text, {
        icon: <Info />,
        hideProgressBar: true,
        autoClose: payload.autoClose ? 10000 : false,
        className: "warning-toast",
        bodyClassName: "toast-body",
      });
      break;
    case "info":
      toast.error(payload.text, {
        icon: <Info />,
        hideProgressBar: true,
        autoClose: payload.autoClose ? 10000 : false,
        className: "warning-toast",
        bodyClassName: "toast-body",
      });
      break;
    default:
      toast.error(payload.text, {
        icon: <Info />,
        hideProgressBar: true,
        autoClose: payload.autoClose ? 10000 : false,
        className: "warning-toast",
        bodyClassName: "toast-body",
      });
      break;
  }
};

export default displayToasts;
